import script from "./colour-picker.vue?vue&type=script&lang=ts&setup=true"
export * from "./colour-picker.vue?vue&type=script&lang=ts&setup=true"

import "@simonwep/pickr/dist/themes/monolith.min.css?vue&type=style&index=0&lang=css&external"
import "@simonwep/pickr/dist/themes/classic.min.css?vue&type=style&index=1&lang=css&external"
import "./colour-picker.vue?vue&type=style&index=2&id=dce82238&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dce82238"]])

export default __exports__